import { themedStyled } from 'common/styles/styletron.theme';

export const SummaryContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  boxShadow: '0px -4px 16px rgba(0, 0, 0, 0.12)',
  borderRadius: '8px 8px 0px 0px',
  padding: '16px',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}));

export const SummaryLeftContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const SummaryRightContainer = themedStyled(
  SummaryLeftContainer,
  ({ $theme }) => ({
    marginTop: '16px',
    justifyContent: 'space-between',
    flex: 1,
    [$theme.mediaQuery.md]: {
      flex: 0,
      marginTop: 0,
    },
  }),
);

export const FormContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  marginTop: '-16px',
  marginLeft: '-16px',
  marginRight: '-16px',
  paddingTop: '16px',
  paddingLeft: '16px',
  paddingRight: '16px',
  overflow: 'scroll',
}));

export const FormDivider = themedStyled('div', {
  marginTop: '120px',
});
